import http from "./http"

export function getRecommendRouteList({params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false}) {
  const url = `/recommendRoute/list?activityId=${params.activityId}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export function getRecommendRouteDetail({params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false}) {
  const url = `/recommendRoute/detail?id=${params.id}`
  params = null
  return http.get({ url, params, headers, finalFunc, showLoading, showToast })
}

export function view({params = {}, headers = {}, finalFunc = null, showLoading = false, showToast = false}) {
  const url = '/recommendRoute/view'
  return http.post({url, params, headers, finalFunc, showLoading, showToast})
}
